import ActionTypes from './../common/ActionTypes';
import Strings from './../common/Strings';
import Constant from './../common/Constant';
import { uiActions } from './index';
import Analytics from '../analytics/Analytics';
import Events from '../analytics/Events';
import { getHoursFromMillis } from '../helpers/workLog';

const firebase = require('firebase/app');
require('firebase/auth');
require('firebase/firestore');

const moment = require('moment');

let todaysWorkLogFetched = false;
let todaysWorkLogSnapshot;

function setLoadingToday(isLoadingToday) {
  return {
    type: ActionTypes.WORK_LOG_LOADING_TODAY,
    isLoadingToday,
  };
}

function setUpdating(isWorkLogUpdating) {
  return {
    type: ActionTypes.WORK_LOG_UPDATING,
    isWorkLogUpdating,
  };
}

function workLogCreated(workLog) {
  return {
    type: ActionTypes.WORK_LOG_CREATED,
    workLog,
  };
}

export function workLogUpdated(workLog) {
  return {
    type: ActionTypes.WORK_LOG_UPDATED,
    workLog,
  };
}

export function workLogDeleted(workLog) {
  return {
    type: ActionTypes.WORK_LOG_DELETED,
    workLog,
  };
}

function setTodayFailed(isFailed) {
  return {
    type: ActionTypes.WORK_LOG_TODAY_FAILED,
    isFailed,
  };
}

function clearTodaysWorkLog() {
  return {
    type: ActionTypes.WORK_LOG_TODAY_CLEAR,
  };
}

function fetchTodaysWorkLog() {
  return dispatch => {
    const { currentUser } = firebase.auth();

    if (currentUser) {
      todaysWorkLogFetched = false;
      dispatch(setLoadingToday(true));
      dispatch(setTodayFailed(false));
      dispatch(clearTodaysWorkLog());
      stopSync();

      todaysWorkLogSnapshot = firebase
        .firestore()
        .collection('workLogs')
        .where('ownerUid', '==', currentUser.uid)
        .where(
          'date',
          '==',
          moment(new Date()).format(Constant.DATE_FORMAT_SHORT),
        )
        .onSnapshot(
          snapshot => {
            snapshot.docChanges().forEach(change => {
              const changeType = change.type;
              const workLog = change.doc.data();
              workLog.id = change.doc.id;

              if (changeType === 'added') {
                dispatch(workLogCreated(workLog));
              } else if (changeType === 'modified') {
                dispatch(workLogUpdated(workLog));
              } else if (changeType === 'removed') {
                dispatch(workLogDeleted(workLog));
              }
            });

            if (!todaysWorkLogFetched) {
              dispatch(setLoadingToday(false));
              dispatch(setTodayFailed(false));
            }

            todaysWorkLogFetched = true;
          },
          () => {
            if (!todaysWorkLogFetched) {
              dispatch(setLoadingToday(false));
              dispatch(setTodayFailed(true));
            }
          },
        );
    }
  };
}

function stopSync() {
  if (todaysWorkLogSnapshot) {
    todaysWorkLogSnapshot();
  }
}

function updateWorkLog(project, workLog, millis) {
  return dispatch => {
    const { currentUser } = firebase.auth();

    if (currentUser) {
      const isUpdate = workLog.id;
      const data = JSON.stringify({
        name: project.name,
        notes: project.notes,
        hourlyRate: project.hourlyRate,
        currencyCode: project.currencyCode,
      });
      Analytics.logEvent(Events.PROJECT_LOG, {
        project: data,
        hours: getHoursFromMillis(millis),
      });

      dispatch(setUpdating(true));

      workLog.ownerUid = currentUser.uid;
      workLog.projectId = project.id;

      if (!workLog.date) {
        workLog.date = moment(new Date()).format(Constant.DATE_FORMAT_SHORT);
      }

      if (isUpdate) {
        // Allow setting companyProjectId empty but not populating it for logs
        // which might have created before company connection
        if (!project.companyProjectId) {
          workLog.companyProjectId = '';
        }
      } else {
        workLog.companyProjectId = project.companyProjectId
          ? project.companyProjectId
          : '';
      }

      let workLogRef;

      if (isUpdate) {
        workLogRef = firebase
          .firestore()
          .collection('workLogs')
          .doc(workLog.id);
      } else {
        workLogRef = firebase
          .firestore()
          .collection('workLogs')
          .doc();
      }

      workLog.totalLoggedMillis += millis;

      if (workLog.totalLoggedMillis <= 0) {
        workLogRef
          .delete()
          .then(() => {
            dispatch(uiActions.activityAddTimeClicked());
            dispatch(uiActions.activityAddClicked(false));
            dispatch(uiActions.workLogBlockClicked());
            dispatch(setUpdating(false));
          })
          .catch(() => {
            dispatch(setUpdating(false));
            dispatch(
              uiActions.showError(
                Strings.ERROR.defaultTitle,
                Strings.ERROR.defaultBody,
              ),
            );
          });
      } else {
        workLogRef
          .set(workLog)
          .then(() => {
            dispatch(uiActions.activityAddTimeClicked());
            dispatch(uiActions.activityAddClicked(false));
            dispatch(uiActions.workLogBlockClicked());
            dispatch(setUpdating(false));
          })
          .catch(() => {
            dispatch(setUpdating(false));
            dispatch(
              uiActions.showError(
                Strings.ERROR.defaultTitle,
                Strings.ERROR.defaultBody,
              ),
            );
          });
      }
    }
  };
}

export const workLogActions = {
  fetchTodaysWorkLog,
  stopSync,
  updateWorkLog,
};



// WEBPACK FOOTER //
// ./src/actions/workLog.js